/*
  This serves two purposes
  1. makes state assignment a bit cleaner in the reducers
  2. more importantly it ensures state is immutable (via `as const`)
*/
export function newState<T>(currentState: T, updatedState: any): T {
  return { ...currentState, ...updatedState } as const;
}
